/**
 * Ryan O'Dowd
 * 2023-12-28
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  ImageBackground,
  Platform,
  View,
} from 'react-native';
import BackgroundGradient from '@components/common/BackgroundGradient';
import ChristmasBackground from './ChristmasBackground';
import LightningBackground from './LightningBackground';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const ScreenWrapper = (props: ScreenWrapperProps) => {
  const styles = hooks.useStyles(getStyles, {noWebHeader: props.noWebHeader});

  const isThunderstorm = hooks.useTypedSelector((state) => state.theme === 'storm');

  const gradientBackground = (opacity) => (
    <BackgroundGradient
      opacity={opacity}
      reverse={true}
      darken={true}
    />
  );

  let specialBackground = null;
  if (isThunderstorm) {
    specialBackground = <LightningBackground initialOpacity={0.8} />;
  } else if (new Date().getMonth() === 11) {
    // it's december
    specialBackground = (
      <React.Fragment>
        <ChristmasBackground />
        {gradientBackground(0.7)}
      </React.Fragment>
    );
  }

  return (
    <View style={styles.container}>
      <ImageBackground
        style={styles.backgroundImageWrapper}
        imageStyle={styles.backgroundImage}
        source={styles.themeBackgroundImage}
      >
        {specialBackground
          ? specialBackground
          : gradientBackground(Platform.OS === 'web' ? 0.8 : (Platform.OS === 'ios' ? 0.9 : 0.72))// @TODO: why do ios and android need to be different? should behave the same...
        }
        <View style={styles.innerContainer}>
          <View style={styles.innerContainer2(!!props.fullWidth, props.isLandingPage)}>{/* @TODO: the scrollbar should be on the outside of this component, not at max width */}{/* @TODO: actually should there be a scroll bar at all?? */}
            {props.children}
          </View>
        </View>
      </ImageBackground>
    </View>
  );
};

class ScreenWrapperProps {
  children: React.ReactNode;

  noWebHeader?: boolean;
  fullWidth?: boolean;
  isLandingPage?: boolean;
};

export default ScreenWrapper;
